/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Importing_Events_ToastInputs */



/**
* | output |
* | --- |
* | "Importing events..." |
*
* @param {Plain_Text_Import_Importing_Events_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_importing_events_toast = /** @type {((inputs?: Plain_Text_Import_Importing_Events_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Importing_Events_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation des evenements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione eventi in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入事件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट आयात किए जा रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando eventos...")
	return /** @type {LocalizedString} */ ("Importing events...")
});